import { create } from 'zustand';

const useAgentStore = create((set) => ({
    agentType: null,
    agentId: null,
    // New unified fields
    id: null,
    publicId: null,
    type: null,
  
    setAgentType: (agentData) => {
      // New unified approach using type field
      if (agentData.type) {
        let agentTypeString;
        switch (agentData.type) {
          case 3:
            agentTypeString = 'Agente';
            break;
          case 2:
            agentTypeString = 'SubConcesionario';
            break;
          case 1:
            agentTypeString = 'Concesionario';
            break;
          default:
            agentTypeString = 'Unknown';
        }
        
        set({ 
          agentType: agentTypeString, 
          agentId: agentData.public_id || agentData.id,
          id: agentData.id,
          publicId: agentData.public_id,
          type: agentData.type
        });
      } 
      // Fallback for legacy structure (backward compatibility)
      else if (agentData.id_agente) {
        set({ agentType: 'Agente', agentId: agentData.id_agente, type: 3 });
      } else if (agentData.id_subconcesionario) {
        set({ agentType: 'SubConcesionario', agentId: agentData.id_subconcesionario, type: 2 });
      } else if (agentData.id_concesionario) {
        set({ agentType: 'Concesionario', agentId: agentData.id_concesionario, type: 1 });
      }
    },
  }));
  
  export default useAgentStore;